<script>
  import { mapGetters } from 'vuex'
  import compounds from '@/components/compounds'
  import logo from '@/components/logo'

  export default {
    name: 'home-page',
    data () {
      return {
        compoundsPageSize: 5
      }
    },
    computed: {
      ...mapGetters([ 'isAuthenticated' ])
    },
    components: {
      'compounds': compounds,
      'logo-bk': logo
    }

  }
</script>

<template>
  <el-main class="home">
    <header>
      <h1>Przedsiębiorstwo Wielobranżowe B&K<em>odczynniki chemiczne</em></h1>
      <div class="logo">
        <logo-bk></logo-bk>
      </div>
    </header>
    <el-row class="articles">
      <article>
        <h2>Nowy serwis</h2>
        <p class="lead">
          Oddajemy w Państwa ręce serwis, który, mamy nadzieję, znacznie usprawni proces
          przygotowywania
          zamówień. Pragnąc maksymalnie ułatwić wyszukiwanie produktów, stworzyliśmy dynamicznie
          filtrowany indeks produktów, pozwalający operować również na nazwach potocznych.
        </p>
      </article>
      <article>
        <h2>Lista produktów</h2>
        <p>
          Poniższa wyszukiwarka pozwoli <strong>na szybkie wybranie</strong> interesujących Państwa
          produktów.
          <strong>Aby złożyć zamówienie</strong> należy założyć konto i zalogować się do serwisu.
        </p>
        <p>
          Pragniemy jednocześnie zaznaczyć, że część produktów funkcjonuje na rynku pod różnymi
          nazwami.
          Sugerujemy więc, w razie negatywnego wyniku wyszukiwania, by skorzystać z formularza
          zapytania
          na naszej stronie lub by potwierdzić dostępność poszukiwanego produktu telefonicznie.
        </p>
      </article>

    </el-row>
    <el-row class="compounds">
      <el-col>
        <compounds :page-size="compoundsPageSize"></compounds>
      </el-col>
    </el-row>
    <el-row class="articles">
      <article>
        <h2 style="color: darkred;">Środki dezynfekcyjne w przystępnych cenach</h2>
        <p class="lead">
          Posiadamy w sprzedaży środek do dezynfekcji <b>Virus Cleaner</b> na bazie czystego lub
          skażonego alkoholu etylowego w cenach zaczynających się już od <b>19 zł</b> za litr.
        </p>

        <p>
          Zamówienia można składać za pośrednictwem naszej strony lub na adres email: <br><i
          class="el-icon-postcard"
          style="display: block-inline; font-size: 2.2rem; margin-top: .2rem; vertical-align: sub;"
        ></i>
          info@chemik.aip.pl<br><br>
        </p>
      </article>
      <article>
        <h2 v-if="!isAuthenticated">Aby złożyć zamówienie</h2>
        <p
          class="lead"
          v-if="!isAuthenticated"
        >
          <el-link
            href="/zaloguj/"
            icon="el-icon-unlock"
            type="primary"
          >Zaloguj
          </el-link>
          się do seriwsu lub...<br/>
          <el-link
            href="/konto/dodaj/"
            icon="el-icon-user"
            type="primary"
          >Utwórz konto
          </el-link>
          jeśli nie zakładałeś jeszcze konta w naszym serwisie.
          <br><br>
          Do założenia konta wymagany jest jedynie adres email.
          <br><br>
        </p>
        <p v-if="!isAuthenticated">
          <el-link
            icon="el-icon-chat-round"
            @click="$emit('show-message-panel', true)"
          >Napisz do nas
          </el-link>
          jeżeli napotkałeś jakiekolwiek problemy z powyższymi operacjami, a&nbsp;postaramy się je
          jak
          najsprawniej rozwiązać.
          <br><br>
          <el-link
            icon="el-icon-link"
            type="primary"
            href="http://old.chemik.aip.pl/"
          >http://old.chemik.aip.pl/
          </el-link>
          tutaj znajdziesz starą wersję serwisu, jeśli z jakiegokolwiek powodu potrzebujesz do niej
          dostępu.
        </p>
      </article>
      <article>
        <h2>Dla laboratoriów chemicznych</h2>
        <p>
          Prowadzimy wysyłkową sprzedaż odczynników chemicznych. Ewentualny odbiór osobisty
          proszę uzgadniać telefonicznie.
        </p>
        <p>
          Asortyment pirotechniczny obsługujemy wyłącznie po wcześniejszym przesłaniu zamówienia
          pocztą lub faksem z pieczątką zamawiającej firmy.
        </p>
        <p>
          Nasze towary nie mają
          dopuszczeń Państwowego Zakładu Higieny ani Państwowego Inspektora Sanitarnego do obrotu
          spożywczego i mogą być stosowane wyłącznie jako odczynniki laboratoryjne lub surowce do
          produkcji nie związanej z żywieniem lub bezposrednim stosowaniu na ludziach.
        </p>
        <p>
          Po założeniu konta, w prosty i szybki sposób, można zarówno wysłać zamówienie na wybrane
          produkty,
          jak również złożyć zapytanie ofertowe. Udostępniamy dla Państwa bogatą bazę pierwiastków i
          związków chemicznych - wiele z nich dostępnych w różnych konsystencjach czy stopniach
          czystości.
          Regularnie też wzbogacać będziemy zarówno naszą ofertę, jak i zakres funkcjonalności
          internetowej
          platformy.
        </p>
        <p>
          Jeśli mają Państwo uwagi lub pomysły, jak usprawnić nasz system, by proces przygotwania
          zamówień był
          możliwie najsprawniejszy, prosimy o przekazanie wszelkich sugestii za pośrednictwem
          formularza do
          komunikacji z nami, pocztą elektroniczną lub telefonicznie.
        </p>
        <p align="right">
          <em>Zespół B&amp;K</em>
        </p>
      </article>
    </el-row>
  </el-main>
</template>

<style lang="sass" scoped>
  @import "./src/styles/common.module.sass"

  .home

    & > header
      align-items: flex-start
      display: flex
      flex-flow: row wrap
      justify-content: flex-start

      & .logo
        display: block
        flex: 0 0 auto
        margin: 1.5rem
        order: 2

      & h1
        display: block
        flex: 0 0 auto
        font-weight: bold
        order: 1
        text-align: right

        & em
          display: block
          font-family: Roboto, Helvetica, sans-serif
          font-size: 1.7rem
          font-weight: normal
          margin-top: .8rem

    & .compounds
      border-top: 2px solid $--color-primary
      border-bottom: 2px solid $--color-primary
</style>



// WEBPACK FOOTER //
// src/components/home-page.vue